import { BsHeartFill, BsHeartbreakFill } from "react-icons/bs";

//API Consts
//export const stacksApi = 'https://api.nakamoto.testnet.hiro.so';
export const stacksApi = 'https://api.mainnet.hiro.so';
export const sentimentApi = 'https://sentiment.derupt.io';

//Explorer Consts
export const stacksExplorer = 'https://explorer.hiro.so';
export const stacksExplorerParam = '?chain=mainnet';
//export const stacksExplorerParam = '?chain=testnet&api=https://api.nakamoto.testnet.hiro.so';

//Network Consts
//export const clientNetwork = "testnet";
export const clientNetwork = "mainnet";

//Contracts Deployer Const
//export const contractDeployer = "ST1ZK0A249B4SWAHVXD70R13P6B5HNKZAA0WNTJTR";
export const contractDeployer = "SP7MKPEA5DVQQ1PQNYPC1P5YRF14CY3CWZF70R01";

// Constracts Consts
export const cryptoCashCoreAddress = contractDeployer + '.cryptocash-core';
export const cryptoCashTokenAddress = contractDeployer + '.cryptocash-token::cryptocash';
export const deruptInterfaceAddress = contractDeployer + '.derupt-interfaces::derupt-interface-token';
export const deruptFeedContractAddress = contractDeployer + '.derupt-feed';
export const deruptSentimentAddress = contractDeployer + '.derupt-sentiment';
export const deruptMinersAddress = contractDeployer + '.derupt-miners';
export const deruptStackersAddress = contractDeployer + '.derupt-stackers';
export const deruptProfilesAddress = contractDeployer + '.derupt-profiles';
export const deruptarsNFTContractAddress = 'SP2KAF9RF86PVX3NEE27DFV1CQX0T4WGR41X3S45C.deruptars::deruptars';
export const bnsContractAddress = 'SP000000000000000000002Q6VF78.bns';

//Dev Const - should be the same as the relative Interface nft owner
//export const devPrincipal = "ST180A283Q28Q7PT7B7CJC1M11YEJQBNYYDMQRATG"; 
export const devPrincipal = "SPZFE1Z8JK9XESEYQ2HK3JJEPTBS2AZ2F5J4B1M9"; 

//Other Consts
export const sentimentOptions = [
    {
        value: 'favorable',
        functionName: 'favorable-reply-message',
        icon: <BsHeartFill size={24} />
    },
    {
        value: 'unfavorable',
        functionName: 'unfavorable-reply-message',
        icon: <BsHeartbreakFill size={24} />
    },
];
